import React from "react";
import Svg from './Svg';
import constants from "../constants";

/**
 * @type {Array} t
 */
let t = constants.countriesAdvanced;

const LanguageSelector = (props) => {
    const onClick = (e, item) => {
        if (item.translationMissingPage) {
            e.preventDefault();
            window.location.href = item.value;
        }
    }

    let selected = t.filter(x => x.selected);

    if (!selected || !selected.length) return null;
    selected = selected[0];

    return (
        <div className="language-selector__wrapper js-language-selector">
            <div>
                {props.currentAsIcon ?
                    <div className="language-selector__icon-wrapper" onClick={e => Toggle(e)}>
                        <img className="icon" src={selected.icon} alt={selected.alt} />
                        <div className="language-selector__icon-label">{selected.text}</div>
                    </div>
                    :
                    <div className="language-selector__current-wrapper" onClick={e => Toggle(e)}>
                        <span>{selected.text}</span>
                        <Svg icon="arrow-right" />
                    </div>
                }
            </div>

            <ul className="language-selector__dropdown js-language-dropdown">
                {t.map((item, index) =>
                    <li key={`figure${index}`}>
                        <a href={!item.translationMissingPage ? item.value : undefined} onClick={(e) => onClick(e, item)} className="language-selector__link">
                            <img className="icon" src={item.icon} alt={item.alt} />
                            <span>{item.text}</span>
                        </a>
                    </li>
                )}
            </ul>
        </div>
    );
};


function Toggle(e) {
    let parentElement = findParentBySelector(e.target,'.js-language-selector');
    let dropdownElement = parentElement.querySelector('.js-language-dropdown');

    if(dropdownElement.className.indexOf('language-selector__dropdown--active') === -1){
        dropdownElement.classList.add('language-selector__dropdown--active');
    }
    else {
        dropdownElement.classList.remove('language-selector__dropdown--active');
    }
};

// added for IE support
function collectionHas(a, b) {
    for(var i = 0, len = a.length; i < len; i ++) {
        if(a[i] == b) return true;
    }
    return false;
}
function findParentBySelector(elm, selector) {
    var all = document.querySelectorAll(selector);
    var cur = elm.parentNode;
    while(cur && !collectionHas(all, cur)) {
        cur = cur.parentNode;
    }
    return cur;
}

export default LanguageSelector;